var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

require('./SectionSide.less');

module.exports = Backbone.View.extend({
    el: '.SectionSide',

    initialize: function () {
        _.bindAll(this, 'onScroll', 'initRecentNews');

        this.$recentNews = this.$('.SectionSide-recentNews');

        this.recentNewsState = 'relative';

        this.initRecentNews();
    },

    initRecentNews: function () {
        this.onScroll.__throttled = _.throttle(this.onScroll, 20);
        $(window).on('scroll', this.onScroll.__throttled);
    },

    onScroll: function () {
        var newsOffsetTop = this.$recentNews.offset().top;
        var newsBottom = this.$recentNews.position().top + this.$recentNews.outerHeight();
        var bottom = this.$el.offset().top + this.$el.height();
        var newsOffsetBottom =  this.$recentNews.offset().top + this.$recentNews.outerHeight();
        var delta = 2;

        // Use delta because of browser error when zooming
        if (this.recentNewsState == 'relative' && newsOffsetBottom + delta < bottom) {
            // If scroll to recent news fixed them
            if (newsOffsetTop <= $(window).scrollTop() + 150) {
                this.$recentNews.addClass('SectionSide-recentNews--isFixed');
                this.recentNewsState = 'fixed';
                this.newsOffsetTop = newsOffsetTop;
            }

            return;
        }

        if (this.recentNewsState == 'fixed') {
            if (newsOffsetTop < this.newsOffsetTop) {
                this.$recentNews.removeClass('SectionSide-recentNews--isFixed');
                this.recentNewsState = 'relative';
            }

            if (newsBottom >= bottom - $(window).scrollTop()) {
                this.$recentNews.removeClass('SectionSide-recentNews--isFixed').addClass('SectionSide-recentNews--isAbsolute');
                this.recentNewsState = 'absolute';
                this.newsScrollTop = $(window).scrollTop();
            }

            return;
        }

        if (this.recentNewsState == 'absolute') {
            if ($(window).scrollTop() < this.newsScrollTop) {
                this.$recentNews.removeClass('SectionSide-recentNews--isAbsolute').addClass('SectionSide-recentNews--isFixed');
                this.recentNewsState = 'fixed';
            }
        }
    }
});




//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/SectionSide/SectionSide.js
// module id = 14
// module chunks = 0